module.exports = __webpack_public_path__ + "img/closeloopimg.868bdb23.png";